import { ChevronDown } from 'lucide-react';

const Title = ({ text }) => (
  <span className="flex items-center gap-2 text-left text-xs font-bold uppercase leading-tight tracking-wide text-slate-800">
    <span className="h-3.5 w-1 shrink-0 rounded-full bg-orange-500" />
    {text}
  </span>
);

// Açılıp kapanabilen menü başlığı (fixed: hep açık)
export const NavGroup = ({ group, open, onToggle, children, divider }) => {
  const wrap = group.fixed && !divider ? 'pt-1' : 'mt-2 border-t border-slate-200 pt-2';
  if (group.fixed || !onToggle) {
    return (
      <div className={wrap} data-testid={`nav-group-${group.key}`}>
        <p className="px-3 pb-1.5 pt-2"><Title text={group.title} /></p>
        <div className="space-y-1">{children}</div>
      </div>
    );
  }
  return (
    <div className={wrap} data-testid={`nav-group-${group.key}`}>
      <button type="button" onClick={onToggle} aria-expanded={open}
        className="flex w-full items-center justify-between gap-2 rounded-md px-3 py-2 transition-colors hover:bg-slate-100"
        data-testid={`nav-group-toggle-${group.key}`}>
        <Title text={group.title} />
        <span className="flex shrink-0 items-center gap-1 text-slate-500">
          {!open && <span className="rounded-full bg-slate-200 px-1.5 text-[10px] font-semibold text-slate-700">{group.items.length}</span>}
          <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
        </span>
      </button>
      {open && <div className="mt-1 space-y-1 animate-in fade-in slide-in-from-top-1 duration-200">{children}</div>}
    </div>
  );
};
